import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const PORTRAIT =
  "https://customer-assets-jai6qajn.emergentagent.net/job_mortgage-elite/artifacts/h1y675gk_StraviaLending_Caitlin_102.jpg";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-32 md:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-20 items-center">
        <Reveal className="md:col-span-5">
          <div
            ref={ref}
            className="overflow-hidden rounded-[4px] aspect-[4/3] md:aspect-[5/4] shadow-[0_4px_40px_-10px_rgba(0,0,0,0.12)]"
            data-testid="about-image-frame"
          >
            <motion.img
              src={PORTRAIT}
              alt="Caitlin Morrison at home with her family"
              style={{ y, scale: 1.15 }}
              className="w-full h-full object-cover"
              data-testid="about-image"
            />
          </div>
        </Reveal>
        <div className="md:col-span-6 md:col-start-7">
          <Reveal>
            <p
              data-testid="about-overline"
              className="text-xs font-semibold tracking-[0.35em] uppercase text-[#CFAEA5] mb-8"
            >
              Meet Your Broker
            </p>
            <h2
              data-testid="about-heading"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-tight text-balance"
            >
              Caitlin <em className="italic text-[#CFAEA5]">Morrison</em>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p
              data-testid="about-body-1"
              className="mt-10 max-w-lg text-base md:text-lg leading-relaxed tracking-wide text-[#908B85]"
            >
              A busy mum of three with a grounded country upbringing, Caitlin
              is family orientated, hard working, honest and reliable — and
              she believes a mortgage should feel considered, not
              transactional. As a mobile broker providing service Australia
              wide, she comes to you — and works with a small number of
              clients at a time, so every application receives her full
              attention.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p
              data-testid="about-body-2"
              className="mt-6 max-w-lg text-base md:text-lg leading-relaxed tracking-wide text-[#908B85]"
            >
              Whether it's your first home, a growing portfolio or a complex
              restructure, you'll deal with Caitlin directly — never a call
              centre — from the first conversation to the day you settle. The
              values she grew up with still guide every file: honesty, hard
              work, and doing right by people.
            </p>
          </Reveal>
          <Reveal delay={0.28}>
            <a
              href="#contact"
              data-testid="about-cta-link"
              className="mt-12 inline-flex items-center gap-3 text-xs font-semibold tracking-[0.3em] uppercase text-[#493E38] border-b border-[#A9ADA1] pb-2 hover:text-[#CFAEA5] transition-colors duration-300"
            >
              Start a conversation
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
